import {
    GET_DOCUMENT_COMMENTS_BY_DOCUMENTID, POST_DOCUMENT_COMMENTS_BY_DOCUMENTID, GET_PROGRESS_COMMENTS,
} from '../type'

const initialState = {
    documentComments: [],
    progressComments: [],
}

export default function documentCommentReducer(state = initialState, action) {
    switch (action.type) {

        case GET_DOCUMENT_COMMENTS_BY_DOCUMENTID:
            return {
                ...state,
                documentComments: action.payload,
                loading: false

            }
        case POST_DOCUMENT_COMMENTS_BY_DOCUMENTID:
            return {
                ...state,
                loading: false
            }
        case GET_PROGRESS_COMMENTS:
            return {
                ...state,
                progressComments: action.payload,
                loading: false
            }

        default: return state
    }

}